import styled from "styled-components";

export const SelectContainer = styled.div`
  input {
    height: 30px;
    width: 400px;
    background-color: "#272626";
    padding: 0px 5px;
    box-sizing: border-box;
    border-radius: 5px;
    outline: none; // tira a borda azul de foco
    color: "#d8d8d8";
    border: 0.5px solid #2d2d2d;
    text-align: center;

    ::placeholder {
      color: grey;
      font-style: italic;
      text-align: center;
    }
  }
`;

export const DropDown = styled.div`
  width: 400px; // mesma largura do input
  background-color: #545454;
  border-radius: 5px;
  margin-top: 10px; // distância do input
  border: 0.5px solid #2d2d2d;
  height: 130px; // tamanho da caixa de seleção
  overflow: auto; // coloca os itens dentro com scroll

  position: absolute;
  z-index: 2;

  ${(props) => {
    if (props.dropSelect) {
      return `display: block;`;
    } else {
      return `display: none;`;
    }
  }}

  ::-webkit-scrollbar {
    background-color: #1d1d1d; /* Cor de fundo do "thumb" */
    width: 12px; // largura do scroll
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #5b5b5b; /* Cor de fundo do "thumb" */
    border-radius: 12px; /* Raio do "thumb" */
  }
`;

export const FocusedItem = styled.div`
  color: #ffffff;
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0px 5px;
  box-sizing: border-box;
  transition: 0.2s;
  cursor: pointer;

  :hover {
    background-color: #121212; // cor que muda ao passar o mouse por cima
    padding-bottom: 7px;
    transition: 0.2s;
  }
`;

export const InputLabel = styled.input`
  ${(props) => {
    if (props.erro && props.value) {
      return `
      color: red;
      border-color: red;
      `;
    }
  }}
`;
